// Input validation utilities — shared between worker and frontend.

import type { VendorSendMethod, FulfillmentChannel, SupplyProgram } from './types';

export const VENDOR_SEND_METHODS: VendorSendMethod[] = ['email', 'manual'];
export const FULFILLMENT_CHANNELS: FulfillmentChannel[] = ['grocery', 'vendor'];
export const SUPPLY_PROGRAMS: SupplyProgram[] = ['kitchen', 'cleaning'];

/** True when `v` is a string with non-whitespace content. */
export function isNonEmptyString(v: unknown): v is string {
  return typeof v === 'string' && v.trim().length > 0;
}

// Deliberately permissive — a real address just needs local@domain.tld shape.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(v: string): boolean {
  return EMAIL_RE.test(v.trim());
}

export function isVendorSendMethod(v: unknown): v is VendorSendMethod {
  return v === 'email' || v === 'manual';
}

export function isFulfillmentChannel(v: unknown): v is FulfillmentChannel {
  return v === 'grocery' || v === 'vendor';
}

export function isSupplyProgram(v: unknown): v is SupplyProgram {
  return v === 'kitchen' || v === 'cleaning';
}
